/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_onboarding_invite_team_description = /** @type {(inputs: {}) => string} */ () => {
	return `Agrega a las personas que administrarán tu empresa en Bloque. Siempre puedes agregar más después.`
};

const en_onboarding_invite_team_description = /** @type {(inputs: {}) => string} */ () => {
	return `Add the people who will manage your company on Bloque. You can always add more later.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const onboarding_invite_team_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.onboarding_invite_team_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("onboarding_invite_team_description", locale)
	if (locale === "es") return es_onboarding_invite_team_description(inputs)
	return en_onboarding_invite_team_description(inputs)
};
export { onboarding_invite_team_description as "onboarding.invite_team.description" }